import { z } from 'zod'

import { validators, HeightUnit, WeightUnit, AmhUnit } from '@gaia-family/lib'

const Scalars = {
  Ref: z.object({ __typename: z.string(), id: z.string() }),
  Money: z.any(),
  Height: z.object({
    unit: z.nativeEnum(HeightUnit),
    value: z.number().int(),
  }),
  Weight: z.object({
    unit: z.nativeEnum(WeightUnit),
    value: z.number().int().gte(0),
  }),
  Amh: z.object({
    unit: z.nativeEnum(AmhUnit),
    value: z.number().gte(0),
  }),
  Int: z.number().int(),
  Float: z.number(),
  NonNegativeInt: z.number().gte(0),
  PositiveInt: z.number().gt(0),
  NonNegativeFloat: z.number().gte(0),
  PositiveFloat: z.number().gt(0),
  NonEmptyString: z.string().min(1),
  Date: validators.IsoDate,
  Time: validators.IsoDate,
  DateTime: validators.IsoDate,
  Timestamp: validators.IsoDate,
  PostalCode: z.string(),
  EmailAddress: z.string().email(),
  LiteralTrue: z.literal(true),
  LiteralFalse: z.literal(false),
}

export const RefSchema: z.ZodSchema<{ __typename: string; id: string }> =
  Scalars.Ref
export const MoneySchema: z.ZodSchema<Gaia.Money> = Scalars.Money
export const WeightSchema: z.ZodSchema<Gaia.Weight> = Scalars.Weight
export const HeightSchema: z.ZodSchema<Gaia.Height> = Scalars.Height
export const AmhSchema: z.ZodSchema<Gaia.Amh> = Scalars.Amh
export const LiteralTrueSchema: z.ZodSchema<true> = Scalars.LiteralTrue
export const LiteralFalseSchema: z.ZodSchema<false> = Scalars.LiteralFalse
export const NonNegativeIntSchema: z.ZodSchema<number> = Scalars.NonNegativeInt
export const PositiveIntSchema: z.ZodSchema<number> = Scalars.PositiveInt
export const NonNegativeFloatSchema: z.ZodSchema<number> =
  Scalars.NonNegativeFloat
export const PositiveFloatSchema: z.ZodSchema<number> = Scalars.PositiveFloat
export const NonEmptyStringSchema: z.ZodSchema<string> = Scalars.NonEmptyString
export const DateSchema: z.ZodSchema<any> = Scalars.Date
export const TimeSchema: z.ZodSchema<any> = Scalars.Time
export const DateTimeSchema: z.ZodSchema<any> = Scalars.DateTime
export const TimestampSchema: z.ZodSchema<any> = Scalars.Timestamp
export const PostalCodeSchema: z.ZodSchema<string> = Scalars.PostalCode
export const EmailAddressSchema: z.ZodSchema<string> = Scalars.EmailAddress
export const Age18 = validators.Age18
